import { redirect, pathToAction, updateScroll, StateGetter } from 'redux-first-router';

import routesMap from 'app/routes';
import { dismissAllErrors } from 'dux/errors';

import {
    ROUTER_LOADED,
    ROUTER_LOADING,
    ROUTER_COMPONENT_LOADED,
    ROUTER_SET_SCROLL,
} from './types';
import { getScroll } from './selectors';
import { Dispatch } from 'redux';

export const routeLoaded = (routeType: string) => ( { type: ROUTER_LOADED, payload: routeType } );
export const routeIsLoading = () => ( { type: ROUTER_LOADING } );
export const componentIsLoaded = (routeType: string) => ( { type: ROUTER_COMPONENT_LOADED, payload: routeType } );
export const saveScroll = ( scroll = '' ) => ( { type: ROUTER_SET_SCROLL, payload: scroll } );

export const restoreScroll = () => ( dispatch: Dispatch, getState: StateGetter ) => {
    const scroll = getScroll( getState() );
    if ( scroll ) {
        dispatch( saveScroll() );
        document.location.hash = scroll;
    }

    if ( document.location.hash ) {
        updateScroll();
    } else {
        window.scrollTo( 0, 0 );
    }
};

export const routeTo = (path: any) => (dispatch: Dispatch) => {
    dispatch( dismissAllErrors() );
    const action = typeof path === 'string' ?
        pathToAction( path, routesMap ) : path;

    dispatch( redirect( action ) );
};
